import * as Types from 'apps/shared/scripts/__generated__/graphql.generated';

import { gql } from '@apollo/client';
import { DesignFragmentDoc } from './DesignFragment.generated';
export type CardFragment = { readonly __typename: 'Card', readonly plan: Types.PlanType, readonly updatedAt: any, readonly createdAt: any, readonly headline: string, readonly id: string, readonly postCount: number, readonly recipientName: string, readonly senderName?: string | null, readonly status: Types.Status, readonly creator: { readonly __typename: 'Profile', readonly id: string }, readonly design: { readonly __typename: 'Design', readonly color: string, readonly id: string, readonly name: string, readonly background: { readonly __typename: 'Background', readonly attachment: string, readonly color: string, readonly size: string, readonly src: string } } };

export type SimpleCardFragment = { readonly __typename: 'Card', readonly createdAt: any, readonly headline: string, readonly id: string, readonly postCount: number, readonly recipientName: string, readonly senderName?: string | null, readonly status: Types.Status };

export const SimpleCardFragmentDoc = gql`
    fragment SimpleCardFragment on Card {
  createdAt
  headline
  id
  postCount
  recipientName
  senderName
  status
}
    `;
export const CardFragmentDoc = gql`
    fragment CardFragment on Card {
  creator {
    id
  }
  design {
    ...DesignFragment
  }
  plan
  updatedAt
  ...SimpleCardFragment
}
    ${DesignFragmentDoc}
${SimpleCardFragmentDoc}`;